import * as $ from "jquery";
import "../../lib/jquery.matchHeight.js";

/* Search-related functions */
export function init(): void {
	$.fn.matchHeight._update()
}





// WEBPACK FOOTER //
// ./js/PFF/modules/stack.ts